import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToHash } from "./SmoothScroll";

const INCLUSI = [
  "accesso alla tua area personale Human Factor;",
  "organizzazione di scadenze e adempimenti;",
  "gestione e condivisione dei documenti;",
  "aggiornamenti sulle attività che riguardano la tua posizione;",
  "canale di comunicazione diretto con il professionista;",
  "supporto e consulenza quando ne hai bisogno;",
  "assistenza continuativa nella gestione del regime forfettario.",
];

export default function Offerta() {
  return (
    <section id="offerta" data-testid="section-offerta" className="relative py-24 lg:py-32">
      <div className="pointer-events-none absolute left-[-6%] top-[20%] h-[400px] w-[400px] rounded-full bg-[#19D6E8]/10 blur-[130px]" />
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div className="flex flex-col gap-7">
          <SectionHead
            eyebrow="L'offerta Human Factor"
            title={
              <>
                Una piattaforma, un servizio, <span className="text-gradient">una relazione professionale</span>
              </>
            }
            sub="Con Human Factor hai a disposizione un sistema integrato per la gestione della tua Partita IVA forfettaria. Il servizio comprende:"
          />
          <Reveal delay={0.2}>
            <div className="flex flex-col items-start gap-4">
              <a
                href="#contatti"
                data-testid="offerta-cta"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToHash("#contatti");
                }}
                className="group inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-[#1B6EF3] to-[#19D6E8] px-8 py-4 font-display text-base font-bold text-white shadow-xl shadow-blue-500/30 transition-all duration-300 hover:scale-[1.03] hover:shadow-cyan-400/40"
              >
                Richiedi informazioni
                <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <p className="text-xs text-slate-500 sm:text-sm">
                Ti aiutiamo a capire se Human Factor è adatto alla tua situazione.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="glow-card rounded-3xl p-7 sm:p-9" data-testid="offerta-lista">
            <ul className="flex flex-col gap-4">
              {INCLUSI.map((item, i) => (
                <li key={item} className="flex items-start gap-3.5 border-b border-white/5 pb-4 last:border-0 last:pb-0">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#1B6EF3] to-[#19D6E8] text-white">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">0{i + 1}</span>
                  <span className="text-sm leading-relaxed text-slate-200 sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 rounded-2xl border border-cyan-400/20 bg-cyan-400/5 p-4 text-xs leading-relaxed text-slate-300 sm:text-sm">
              Tutto viene gestito all'interno dello stesso servizio, per offrirti maggiore chiarezza, continuità e
              semplicità.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
